import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from "@helium10/re-ui-components";
import styled from "styled-components";
import { Container } from "../../Styles";
export const SkeletonDescription = () => {
    return (_jsx(Container, { children: _jsx(Description, {}) }));
};
const Description = styled(Skeleton) `
  height: 40px;
  width: 200px;
`;
